"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7385],{

/***/ 87385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ usePriceAlert; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var aws_amplify_auth__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(83072);
/* harmony import */ var _store_actions_event__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(61748);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99280);
/* harmony import */ var _lib_utilities_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45425);
/* harmony import */ var _store_selectors_user__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15433);
/* harmony import */ var _lib_services_userService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24989);
/* harmony import */ var _store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99017);
/* harmony import */ var _store_reducers_error__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68199);
/* harmony import */ var _lib_loaders__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27386);
/* harmony import */ var _lib_errors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82628);
/* harmony import */ var _store_selectors_locoSpace__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68091);
/* harmony import */ var _store_reducers_locoSpace__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(95223);
/* harmony import */ var _lib_services_searchService__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74829);



















var usePriceAlert = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var isAuthenticated = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_selectors_user__WEBPACK_IMPORTED_MODULE_4__/* .selectIsAuthenticated */ .vN);
    var priceAlertList = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_selectors_locoSpace__WEBPACK_IMPORTED_MODULE_10__/* .selectPriceAlertList */ .DX);
    var getActivePriceAlerts = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        var LOADER, ERROR;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    LOADER = _lib_loaders__WEBPACK_IMPORTED_MODULE_8__/* .LOADERS.fetchingPriceAlerts */ .Y.fetchingPriceAlerts;
                    ERROR = _lib_errors__WEBPACK_IMPORTED_MODULE_9__/* .ERRORS.fetchingPriceAlerts */ .Sg.fetchingPriceAlerts;
                    return [
                        4,
                        (0,aws_amplify_auth__WEBPACK_IMPORTED_MODULE_15__/* .fetchAuthSession */ .y)().then(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(data) {
                                var ref, ref1, token;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            token = (ref = data.tokens) === null || ref === void 0 ? void 0 : (ref1 = ref.idToken) === null || ref1 === void 0 ? void 0 : ref1.toString();
                                            return [
                                                4,
                                                (0,_lib_services_userService__WEBPACK_IMPORTED_MODULE_5__/* .getActivePriceAlertsService */ .tX)({
                                                    token: token,
                                                    pageNumber: 1,
                                                    pageSize: 10
                                                }).then(function(response) {
                                                    dispatch((0,_store_reducers_locoSpace__WEBPACK_IMPORTED_MODULE_11__/* .addPriceAlertList */ .Lk)(response.items));
                                                    dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                                                }).catch(function() {
                                                    dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                                                    dispatch((0,_store_reducers_error__WEBPACK_IMPORTED_MODULE_7__/* .addError */ .iT)({
                                                        key: ERROR,
                                                        message: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .constants.errorMessages.fetchingPriceAlerts */ ._G.errorMessages.fetchingPriceAlerts
                                                    }));
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(data) {
                                return _ref.apply(this, arguments);
                            };
                        }()).catch(function() {
                            dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                            dispatch((0,_store_reducers_error__WEBPACK_IMPORTED_MODULE_7__/* .addError */ .iT)({
                                key: ERROR,
                                message: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .constants.errorMessages.userCredentials */ ._G.errorMessages.userCredentials
                            }));
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        dispatch
    ]);
    var getExpiredPriceAlerts = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        var LOADER, ERROR;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    LOADER = _lib_loaders__WEBPACK_IMPORTED_MODULE_8__/* .LOADERS.fetchingPriceAlerts */ .Y.fetchingPriceAlerts;
                    ERROR = _lib_errors__WEBPACK_IMPORTED_MODULE_9__/* .ERRORS.fetchingPriceAlerts */ .Sg.fetchingPriceAlerts;
                    return [
                        4,
                        (0,aws_amplify_auth__WEBPACK_IMPORTED_MODULE_15__/* .fetchAuthSession */ .y)().then(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(data) {
                                var ref, ref1, token;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            token = (ref = data.tokens) === null || ref === void 0 ? void 0 : (ref1 = ref.idToken) === null || ref1 === void 0 ? void 0 : ref1.toString();
                                            return [
                                                4,
                                                (0,_lib_services_userService__WEBPACK_IMPORTED_MODULE_5__/* .getExpiredPriceAlertsService */ .c2)({
                                                    token: token,
                                                    pageNumber: 1,
                                                    pageSize: 10
                                                }).then(function(response) {
                                                    dispatch((0,_store_reducers_locoSpace__WEBPACK_IMPORTED_MODULE_11__/* .addExpiredPriceAlertList */ .gw)(response.items));
                                                    dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                                                }).catch(function() {
                                                    dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                                                    dispatch((0,_store_reducers_error__WEBPACK_IMPORTED_MODULE_7__/* .addError */ .iT)({
                                                        key: ERROR,
                                                        message: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .constants.errorMessages.fetchingPriceAlerts */ ._G.errorMessages.fetchingPriceAlerts
                                                    }));
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(data) {
                                return _ref.apply(this, arguments);
                            };
                        }()).catch(function() {
                            dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                            dispatch((0,_store_reducers_error__WEBPACK_IMPORTED_MODULE_7__/* .addError */ .iT)({
                                key: ERROR,
                                message: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .constants.errorMessages.userCredentials */ ._G.errorMessages.userCredentials
                            }));
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        dispatch
    ]);
    var doesPriceAlertExist = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(vehiclePrice) {
        var priceAlert = [];
        if (isAuthenticated) {
            priceAlert = priceAlertList.filter(function(item) {
                return item.vehicleId === vehiclePrice.vehicleId;
            });
            return priceAlert.length > 0 ? priceAlert[0] : false;
        }
        return false;
    }, [
        isAuthenticated,
        priceAlertList
    ]);
    var priceAlertDifferencesToCurrentLeaseProfile = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(vehiclePrice, priceAlert) {
        var differences = {};
        if (!priceAlert.mileage.includes(vehiclePrice.mileage)) {
            differences.mileage = vehiclePrice.mileage;
        }
        if (!priceAlert.leaseType.includes(vehiclePrice.leaseType)) {
            differences.leaseType = vehiclePrice.leaseType;
        }
        if (!priceAlert.initialPaymentInMonths.includes(vehiclePrice.initialPaymentInMonths)) {
            differences.initialPaymentInMonths = vehiclePrice.initialPaymentInMonths;
        }
        if (!priceAlert.term.includes(vehiclePrice.term)) {
            differences.term = vehiclePrice.term;
        }
        return Object.keys(differences).length > 0 ? differences : null;
    }, []);
    var onCreatePriceAlert = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(param) {
            var payload, selectedVehiclePrice, LOADER, ERROR;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        payload = param.payload, selectedVehiclePrice = param.selectedVehiclePrice;
                        LOADER = _lib_loaders__WEBPACK_IMPORTED_MODULE_8__/* .LOADERS.addingPriceAlert */ .Y.addingPriceAlert;
                        ERROR = _lib_errors__WEBPACK_IMPORTED_MODULE_9__/* .ERRORS.addingPriceAlert */ .Sg.addingPriceAlert;
                        if (!isAuthenticated) return [
                            3,
                            2
                        ];
                        dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .addLoader */ .HZ)(LOADER));
                        dispatch((0,_store_reducers_error__WEBPACK_IMPORTED_MODULE_7__/* .removeError */ .eO)(ERROR));
                        return [
                            4,
                            (0,aws_amplify_auth__WEBPACK_IMPORTED_MODULE_15__/* .fetchAuthSession */ .y)().then(function(data) {
                                var ref, ref1;
                                var token = (ref = data.tokens) === null || ref === void 0 ? void 0 : (ref1 = ref.idToken) === null || ref1 === void 0 ? void 0 : ref1.toString();
                                (0,_lib_services_userService__WEBPACK_IMPORTED_MODULE_5__/* .addPriceAlertService */ .Gh)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, payload), {
                                    token: token
                                })).then(function() {
                                    var includeVat = selectedVehiclePrice && selectedVehiclePrice.leaseType === _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .FILTER_LEASE_TYPES_PERSONAL */ .m_;
                                    dispatch((0,_store_actions_event__WEBPACK_IMPORTED_MODULE_18__/* .postAnalyticsEvent */ .gR)({
                                        event: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .constants.eventTypes.createPriceAlert */ ._G.eventTypes.createPriceAlert
                                    }));
                                    /* eslint-disable camelcase */ if (typeof window.fbq !== "undefined" && selectedVehiclePrice) {
                                        window.fbq("track", "AddToWishlist", {
                                            content_type: "vehicle_offer",
                                            content_ids: "".concat(selectedVehiclePrice.id),
                                            value: 1,
                                            make: "".concat(selectedVehiclePrice.manufacturerName),
                                            model: "".concat(selectedVehiclePrice.modelName),
                                            trim: "".concat(selectedVehiclePrice.derivativeName),
                                            transmission: "".concat(selectedVehiclePrice.transmissionTypeName),
                                            body_style: "".concat(selectedVehiclePrice.bodyStyleName),
                                            fuel_type: "".concat(selectedVehiclePrice.fuelTypeName),
                                            drivetrain: "".concat((0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_3__/* .driveTypeAbbreviation */ .BA)(selectedVehiclePrice.driveTypeName)),
                                            state_of_vehicle: "New",
                                            country: "United Kingdom",
                                            price: "".concat(includeVat ? (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_3__/* .addVatToPrice */ .QR)(selectedVehiclePrice.monthlyPayment) : selectedVehiclePrice.monthlyPayment.toFixed(2)),
                                            currency: "GBP"
                                        });
                                    }
                                    if (typeof window.ttq !== "undefined" && selectedVehiclePrice) {
                                        window.ttq.track("AddToWishlist", {
                                            content_id: "".concat(selectedVehiclePrice.id),
                                            content_type: "product",
                                            quantity: 1,
                                            value: "".concat(includeVat ? (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_3__/* .addVatToPrice */ .QR)((0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_3__/* .calculateTotalDealCost */ .sU)(selectedVehiclePrice)) : (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_3__/* .calculateTotalDealCost */ .sU)(selectedVehiclePrice)),
                                            price: "".concat(includeVat ? (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_3__/* .addVatToPrice */ .QR)(selectedVehiclePrice.monthlyPayment) : selectedVehiclePrice.monthlyPayment.toFixed(2)),
                                            currency: "GBP"
                                        });
                                    }
                                    getActivePriceAlerts();
                                    dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                                }).catch(function() {
                                    dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                                    dispatch((0,_store_reducers_error__WEBPACK_IMPORTED_MODULE_7__/* .addError */ .iT)({
                                        key: ERROR,
                                        message: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .constants.errorMessages.addingPriceAlert */ ._G.errorMessages.addingPriceAlert
                                    }));
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            payload
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        dispatch,
        isAuthenticated,
        getActivePriceAlerts
    ]);
    var onRemovePriceAlert = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(vehicleId) {
            var LOADER, ERROR;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        LOADER = _lib_loaders__WEBPACK_IMPORTED_MODULE_8__/* .LOADERS.removingPriceAlert */ .Y.removingPriceAlert;
                        ERROR = _lib_errors__WEBPACK_IMPORTED_MODULE_9__/* .ERRORS.removingPriceAlert */ .Sg.removingPriceAlert;
                        if (!isAuthenticated) return [
                            3,
                            2
                        ];
                        dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .addLoader */ .HZ)(LOADER));
                        dispatch((0,_store_reducers_error__WEBPACK_IMPORTED_MODULE_7__/* .removeError */ .eO)(ERROR));
                        return [
                            4,
                            (0,aws_amplify_auth__WEBPACK_IMPORTED_MODULE_15__/* .fetchAuthSession */ .y)().then(function(data) {
                                var ref, ref1;
                                var token = (ref = data.tokens) === null || ref === void 0 ? void 0 : (ref1 = ref.idToken) === null || ref1 === void 0 ? void 0 : ref1.toString();
                                (0,_lib_services_userService__WEBPACK_IMPORTED_MODULE_5__/* .removePriceAlertService */ .ZU)({
                                    vehicleId: vehicleId,
                                    token: token
                                }).then(function() {
                                    dispatch((0,_store_actions_event__WEBPACK_IMPORTED_MODULE_18__/* .postAnalyticsEvent */ .gR)({
                                        event: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .constants.eventTypes.removePriceAlert */ ._G.eventTypes.removePriceAlert
                                    }));
                                    dispatch((0,_store_reducers_locoSpace__WEBPACK_IMPORTED_MODULE_11__/* .removePriceAlert */ ._G)(vehicleId));
                                    dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                                }).catch(function() {
                                    dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                                    dispatch((0,_store_reducers_error__WEBPACK_IMPORTED_MODULE_7__/* .addError */ .iT)({
                                        key: ERROR,
                                        message: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .constants.errorMessages.removePriceAlert */ ._G.errorMessages.removePriceAlert
                                    }));
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function(vehicleId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        dispatch,
        isAuthenticated
    ]);
    var getDealsForPriceAlert = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(priceAlert) {
            var LOADER, ERROR;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        LOADER = _lib_loaders__WEBPACK_IMPORTED_MODULE_8__/* .LOADERS.fetchingDealsForPriceAlert */ .Y.fetchingDealsForPriceAlert;
                        ERROR = _lib_errors__WEBPACK_IMPORTED_MODULE_9__/* .ERRORS.fetchingDealsForPriceAlert */ .Sg.fetchingDealsForPriceAlert;
                        return [
                            4,
                            (0,_lib_services_searchService__WEBPACK_IMPORTED_MODULE_12__/* .getDealsForPriceAlertService */ .zT)({
                                leaseType: priceAlert.leaseType,
                                mileage: priceAlert.mileage,
                                term: priceAlert.term,
                                initialPaymentInMonths: priceAlert.initialPaymentInMonths,
                                vehicleId: priceAlert.vehicleId,
                                sorting: 2
                            }).then(function(response) {
                                dispatch((0,_store_reducers_locoSpace__WEBPACK_IMPORTED_MODULE_11__/* .addPriceAlertWithDealsAndVehicleList */ .Ak)({
                                    priceAlert: priceAlert,
                                    results: response.results,
                                    vehicle: response.vehicle
                                }));
                                dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                            }).catch(function() {
                                dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                                dispatch((0,_store_reducers_error__WEBPACK_IMPORTED_MODULE_7__/* .addError */ .iT)({
                                    key: ERROR,
                                    message: "There has been an issue finding deals for your price alert. Please try again later."
                                }));
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(priceAlert) {
            return _ref.apply(this, arguments);
        };
    }(), [
        dispatch
    ]);
    var getVehiclesForExpiredPriceAlert = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(priceAlert) {
            var LOADER, ERROR;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        LOADER = _lib_loaders__WEBPACK_IMPORTED_MODULE_8__/* .LOADERS.fetchingDealsForPriceAlert */ .Y.fetchingDealsForPriceAlert;
                        ERROR = _lib_errors__WEBPACK_IMPORTED_MODULE_9__/* .ERRORS.fetchingDealsForPriceAlert */ .Sg.fetchingDealsForPriceAlert;
                        return [
                            4,
                            (0,_lib_services_searchService__WEBPACK_IMPORTED_MODULE_12__/* .getDealsForPriceAlertService */ .zT)({
                                leaseType: priceAlert.leaseType,
                                mileage: priceAlert.mileage,
                                term: priceAlert.term,
                                initialPaymentInMonths: priceAlert.initialPaymentInMonths,
                                vehicleId: priceAlert.vehicleId,
                                sorting: 2
                            }).then(function(response) {
                                dispatch((0,_store_reducers_locoSpace__WEBPACK_IMPORTED_MODULE_11__/* .addExpiredPriceAlertWithDealsAndVehicleList */ .vI)({
                                    priceAlert: priceAlert,
                                    results: response.results,
                                    vehicle: response.vehicle
                                }));
                                dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                            }).catch(function() {
                                dispatch((0,_store_reducers_loader__WEBPACK_IMPORTED_MODULE_6__/* .removeLoader */ .Zn)(LOADER));
                                dispatch((0,_store_reducers_error__WEBPACK_IMPORTED_MODULE_7__/* .addError */ .iT)({
                                    key: ERROR,
                                    message: "There has been an issue finding deals for your price alert. Please try again later."
                                }));
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(priceAlert) {
            return _ref.apply(this, arguments);
        };
    }(), [
        dispatch
    ]);
    var onUpdatePriceAlertList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (priceAlertList.length > 0) {
            priceAlertList.map(function(priceAlert) {
                getDealsForPriceAlert(priceAlert);
            });
        }
    }, [
        getDealsForPriceAlert,
        priceAlertList
    ]);
    return {
        getActivePriceAlerts: getActivePriceAlerts,
        getExpiredPriceAlerts: getExpiredPriceAlerts,
        doesPriceAlertExist: doesPriceAlertExist,
        priceAlertDifferencesToCurrentLeaseProfile: priceAlertDifferencesToCurrentLeaseProfile,
        onCreatePriceAlert: onCreatePriceAlert,
        onRemovePriceAlert: onRemovePriceAlert,
        getDealsForPriceAlert: getDealsForPriceAlert,
        getVehiclesForExpiredPriceAlert: getVehiclesForExpiredPriceAlert,
        onUpdatePriceAlertList: onUpdatePriceAlertList
    };
};


/***/ }),

/***/ 68091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C6": function() { return /* binding */ selectArePriceAlertsStale; },
/* harmony export */   "DX": function() { return /* binding */ selectPriceAlertList; },
/* harmony export */   "KK": function() { return /* binding */ selectExpiredPriceAlertWithVehicleList; },
/* harmony export */   "TK": function() { return /* binding */ selectComparisonVehicles; },
/* harmony export */   "Zv": function() { return /* binding */ selectExpiredPriceAlertList; },
/* harmony export */   "av": function() { return /* binding */ selectVehiclesInComparisonCount; },
/* harmony export */   "g7": function() { return /* binding */ selectPriceAlertWithDealsAndVehicleList; },
/* harmony export */   "l7": function() { return /* binding */ selectPriceAlertManufacturerList; }
/* harmony export */ });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

var getLocoSpace = function(state) {
    return state.locoSpace;
};
var selectPriceAlertList = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getLocoSpace
], function(locoSpace) {
    return locoSpace.priceAlertList;
});
var selectExpiredPriceAlertList = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getLocoSpace
], function(locoSpace) {
    return locoSpace.priceAlertExpiredList;
});
var selectPriceAlertWithDealsAndVehicleList = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getLocoSpace
], function(locoSpace) {
    return locoSpace.priceAlertWithDealsAndVehicleList;
});
var selectExpiredPriceAlertWithVehicleList = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getLocoSpace
], function(locoSpace) {
    return locoSpace.expiredPriceAlertWithVehicleList;
});
var selectPriceAlertManufacturerList = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getLocoSpace
], function(locoSpace) {
    var list = locoSpace.priceAlertWithDealsAndVehicleList;
    var manufacturers = list.map(function(item) {
        return {
            name: item.vehicle.manufacturerName,
            id: item.vehicle.manufacturer
        };
    });
    var filteredManufacturers = manufacturers.filter(function(value, index, self) {
        return index === self.findIndex(function(t) {
            return t.place === value.place && t.name === value.name;
        });
    });
    return filteredManufacturers;
});
var selectComparisonVehicles = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getLocoSpace
], function(locoSpace) {
    return locoSpace.comparison;
});
var selectVehiclesInComparisonCount = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getLocoSpace
], function(locoSpace) {
    return locoSpace.comparison.length;
});
var selectArePriceAlertsStale = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getLocoSpace
], function(locoSpace) {
    return locoSpace.stalePriceAlerts;
});


/***/ })

}]);